"use client";

import * as React from "react";

import type { CalculatorFormatters } from "@/lib/pricing-calculator/format";
import { createFormatters } from "@/lib/pricing-calculator/format";

export interface CalculatorEnvironment {
  locale: string;
  /** Currency the visitor has chosen, preset from the request locale. */
  currency: string;
  currencySymbol: string;
  format: CalculatorFormatters;
}

const CalculatorContext = React.createContext<CalculatorEnvironment | null>(
  null
);

export function CalculatorProvider({
  locale,
  currency,
  children,
}: {
  locale: string;
  currency: string;
  children: React.ReactNode;
}) {
  const value = React.useMemo<CalculatorEnvironment>(() => {
    const format = createFormatters(locale, currency);
    return {
      locale,
      currency,
      currencySymbol: format.currencySymbol,
      format,
    };
  }, [locale, currency]);
  return (
    <CalculatorContext.Provider value={value}>
      {children}
    </CalculatorContext.Provider>
  );
}

export function useCalculatorEnvironment(): CalculatorEnvironment {
  const value = React.useContext(CalculatorContext);
  if (!value) {
    throw new Error("useCalculatorEnvironment requires CalculatorProvider");
  }
  return value;
}
